import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Article {
  id: number;
  pathimage: string;
  pathvideo: string;
  position: string;
  active: string;
  typemedia: string;
  imagemedia: string;
  typeclick: string;
  seen: number;
  datenotifs: string;
  statnotif: number;
  creationDate: string;
  description: string;
  label: string;
}

export interface ArticleApiResponse {
  error: string;
  response: Article[];
}

@Injectable({
  providedIn: 'root',
})
export class ConseilDeliceService {
  private baseUrl = `${environment.apiUrl.replace(/\/$/, '')}/articlePublicitaire/`;

  constructor(private http: HttpClient) {}

  getArticles(
    nameOrg: string,
    position: string,
    numberPage: number,
    sizePage: number
  ): Observable<ArticleApiResponse> {
    const url = `${this.baseUrl}listArticlePublicitaire`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { nameOrg, position, numberPage, sizePage };
    return this.http.post<ArticleApiResponse>(url, body, { headers });
  }
}
